// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3DA-_","productName":"Table_productName__22cfE"};